import React, { useEffect, useState, useMemo } from 'react';
import Select from 'react-select';
import get from 'lodash/get';
import { AUTO_ADD_INFO_FOR } from '../../submitters-field-element-settings';

const optionKey = 'requiredFor';

const selectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9,
  }),
};

const RequiredForSetting = ({ element, onChange, submitter2Included, submitterRepresentativeIncluded, submitterResidentIncluded }) => {
  const options = useMemo(() => {
    const optionsList = [
      { value: 'any', label: '----' },
      { value: 'submitter', label: 'Submitter' },
      { value: 'initiator', label: 'Initiator' },
    ];

    // Whoever submits at step 2 of a strict order, the same step the Submitters
    // field's "Submitter 2" auto entry fills for. Never required without one.
    if (submitter2Included) {
      optionsList.push({ value: AUTO_ADD_INFO_FOR.SUBMITTER_2, label: 'Submitter 2' });
    }

    if (submitterRepresentativeIncluded) {
      optionsList.push({ value: 'representative', label: 'Submitter (Representative)' });
    }

    if (submitterResidentIncluded) {
      optionsList.push({ value: 'resident', label: 'Submitter (Resident)' });
    }

    return optionsList;
  }, [submitter2Included, submitterRepresentativeIncluded, submitterResidentIncluded]);

  const [requiredFor, setRequiredFor] = useState(get(element, `options[${optionKey}]`));

  const getOptionByValue = (value) => {
    return options.find((opt) => opt.value === value);
  };

  useEffect(() => {
    setRequiredFor(get(element, `options[${optionKey}]`));
  }, [element]);

  const activeOption = getOptionByValue(requiredFor);

  const handleChange = (value) => {
    const newValue = value.value;
    setRequiredFor(newValue);
    onChange(newValue === 'any' ? undefined : newValue, optionKey, element.id);
  };

  return (
    <div className="property-item">
      <h3 className="form-builder-aside-property-sub-title">Required for</h3>
      <div className="form-control-item">
        <Select className="form-control-select" value={activeOption} options={options} styles={selectStyles} onChange={handleChange} />
      </div>
    </div>
  );
};

export default RequiredForSetting;
